// extracted by mini-css-extract-plugin
module.exports = {"logo":"_76e687a"};